module.exports = __webpack_public_path__ + "img/map_icon_issue.05619e07.svg";